// extracted by mini-css-extract-plugin
export default {"card":"Post_card__dzf0c","title":"Post_title__Zhle9"};